import React from 'react';
import { Row, Col, Divider } from 'antd';
import { isEqual } from 'lodash';

import HistoryLog from '../../../HistoryLog';
import HistoryField from '../../../HistoryField';
import {
  AssignmentHistoryDetailsModel,
  AssignmentHistoryResponse,
} from 'api/adminApiClient';
import { formatNumberAsCurrency } from 'utils/numberUtils';

import styles from '../../../HistoryCard.module.less';

type Props = {
  historyId: string;
  historyDetails: AssignmentHistoryDetailsModel;
};
export default function AdditionalInformationDetailsCard(props: Props) {
  const { historyId, historyDetails } = props;
  const { oldData, newData } = historyDetails;

  const hasMarkupChanged = !isEqual(
    oldData?.additionalInfo?.markup || '',
    newData?.additionalInfo?.markup || '',
  );
  const hasGrossMarginPercentChanged = !isEqual(
    oldData?.additionalInfo?.grossMarginPercent || '',
    newData?.additionalInfo?.grossMarginPercent || '',
  );
  const hasGrossMarginPerHourChanged = !isEqual(
    oldData?.additionalInfo?.grossMarginPerHour || '',
    newData?.additionalInfo?.grossMarginPerHour || '',
  );
  const hasAnticipatedWeeklyCommissionChanged = !isEqual(
    oldData?.additionalInfo?.anticipatedWeeklyCommission || '',
    newData?.additionalInfo?.anticipatedWeeklyCommission || '',
  );
  const hasConfirmationCommissionStructureChanged = !isEqual(
    oldData?.additionalInfo?.confirmationCommissionStructure || '',
    newData?.additionalInfo?.confirmationCommissionStructure || '',
  );

  const renderAdditionalInformationSection = (
    assignment?: AssignmentHistoryResponse,
  ) => {
    if (!assignment?.additionalInfo) return null;

    const { additionalInfo } = assignment;

    const sectionName = 'additional-information';
    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Additional information</div>
          </Col>
          {hasMarkupChanged && (
            <HistoryField
              title="Markup"
              value={formatNumberAsCurrency({
                num: additionalInfo?.markup,
                isRightSymbol: false,
                symbol: '%',
              })}
              dataId={`${sectionName}-markup-field`}
            />
          )}
          {hasGrossMarginPercentChanged && (
            <HistoryField
              title="Gross margin %"
              value={formatNumberAsCurrency({
                num: additionalInfo?.grossMarginPercent,
                symbol: '%',
                isRightSymbol: false,
              })}
              dataId={`${sectionName}-gross-margin-percent-field`}
            />
          )}
          {hasGrossMarginPerHourChanged && (
            <HistoryField
              title="Gross margin/hr"
              value={formatNumberAsCurrency({
                num: additionalInfo?.grossMarginPerHour,
              })}
              dataId={`${sectionName}-gross-margin-per-hour-field`}
            />
          )}
          {hasAnticipatedWeeklyCommissionChanged && (
            <HistoryField
              title="Anticipated commission"
              value={formatNumberAsCurrency({
                num: additionalInfo?.anticipatedWeeklyCommission,
              })}
              dataId={`${sectionName}-anticipated-commission-field`}
            />
          )}
          {hasConfirmationCommissionStructureChanged && (
            <HistoryField
              title="Commission structure confirmed"
              value={
                additionalInfo?.confirmationCommissionStructure ? 'Yes' : 'No'
              }
              dataId={`${sectionName}-confirmation-commission-structure-field`}
            />
          )}
        </Row>

        <Divider />
      </>
    );
  };

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderAdditionalInformationSection(oldData)}
      newData={renderAdditionalInformationSection(newData)}
    />
  );
}
